export const addOneDay = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  date.setDate(date.getDate() + 1); // прибавляем 1 день
  return date.toLocaleDateString("ru-RU", {
    weekday: "long", // 👈 добавляет день недели
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
